<form [formGroup]="formFuncoesAdmin">

    <!-- TITULO -->
    <section class="section-saudacao">
      <div class="container">
        <h2 class="titulo-page">Painel Admin</h2>
      </div>
    </section>

    <div class="container">
        <h1 class="titulo-page">Processos</h1>
    </div>        
    <section class="section-filtro">
      <div class="container align-items-center">        
        <div class="fila-processos">
          <div class="etiqueta-titulo">
              <p><b>Atualizar Status de Chamados e Envolvidos Atendidos</b></p>
          </div>
          <div class="container-btns">
              <input type="submit" class="btn_primary" value="Atualizar Status" (click)="AtualizarStatusChamados()" />
          </div>
          <div class="resultado-atualizar-status">
            <p>{{ resultadoAtualizarStatus }}</p>
          </div>
        </div>
      </div>
    </section>

</form>
<br /><br />
<form [formGroup]="formFuncoesAdminSubCategorias">

    <div class="container">
        <h1 class="titulo-page">Sub-Categorias</h1>
    </div>        
    <section class="section-filtro">
      <div class="container align-items-center">        
        <div class="fila-processos">
          <div class="etiqueta-titulo">
              <p><b>Atualizar Descrição Sub-Categoria </b></p>
          </div>
          <div class="section-text">
            <label for="codigoSubCategoria">Codigo Sub-Categoria:</label>
            <ng-select
              [items]="subCategorias"
              bindLabel="descricaoSubCategoria"
              bindValue="codigoSubCategoria"
              placeholder="Selecione uma Categoria"
              formControlName="codigoSubCategoria"
              class="ng-select-custom">
            </ng-select>
          </div>
          <div class="section-text">
            <label for="codigoSubCategoria">Descrição Sub-Categoria:</label>
            <input
              type="text"
              name="descSubCategoria"
              class="input-standard"
              formControlName="descSubCategoria"
              aria-label="Informe a Descrição da Sub Categoria"
            />
          </div>
          <div class="container-btns">
              <input type="submit" class="btn_primary" value="Atualizar Sub-Categorias" (click)="AtualizarDescSubCategoria()" />
          </div>
          <div class="resultado-atualizar-sub-categorias">
            <p>{{ resultadoAtualizarSubCategoria }}</p>
          </div>
        </div>
      </div>
    </section>

</form>

<ngx-spinner
    bdColor="rgba(51,51,51,0.8)"
    size="medium"
    color="#fff"
    type="ball-scale-multiple"
    >
    <p style="font-size: 20px; color: white">Carregando ...</p>
</ngx-spinner>